"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    return (_extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        b.hasOwnProperty(p) && (d[p] = b[p]);
      }
    })(d, b);
  };

  return function (d, b) {
    function __() {
      this.constructor = d;
    }

    _extendStatics(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    utils_1 = require("./utils"),
    types_1 = require("./types"),
    Dots_1 = require("./Dots"),
    Arrows_1 = require("./Arrows"),
    CarouselItems_1 = require("./CarouselItems"),
    common_1 = require("./utils/common"),
    defaultTransitionDuration = 400,
    defaultTransition = "transform 400ms ease-in-out",
    Carousel = function (_super) {
  function Carousel(props) {
    var _this = _super.call(this, props) || this;

    return _this.containerRef = React.createRef(), _this.listRef = React.createRef(), _this.state = {
      itemWidth: 0,
      slidesToShow: 0,
      currentSlide: 0,
      totalItems: React.Children.count(props.children),
      deviceType: "",
      domLoaded: !1,
      transform: 0,
      containerWidth: 0
    }, _this.onResize = _this.onResize.bind(_this), _this.handleDown = _this.handleDown.bind(_this), _this.handleMove = _this.handleMove.bind(_this), _this.handleOut = _this.handleOut.bind(_this), _this.onKeyUp = _this.onKeyUp.bind(_this), _this.handleEnter = _this.handleEnter.bind(_this), _this.setIsInThrottle = _this.setIsInThrottle.bind(_this), _this.next = utils_1.throttle(_this.next.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.previous = utils_1.throttle(_this.previous.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.goToSlide = utils_1.throttle(_this.goToSlide.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.onMove = !1, _this.initialX = 0, _this.lastX = 0, _this.isAnimationAllowed = !1, _this.direction = "", _this.initialY = 0, _this.isInThrottle = !1, _this.transformPlaceHolder = 0, _this;
  }

  return __extends(Carousel, _super), Carousel.prototype.resetTotalItems = function () {
    var _this = this,
        totalItems = React.Children.count(this.props.children),
        currentSlide = utils_1.notEnoughChildren(this.state) ? 0 : Math.max(0, Math.min(this.state.currentSlide, totalItems));

    this.setState({
      totalItems: totalItems,
      currentSlide: currentSlide
    }, function () {
      _this.setContainerAndItemWidth(_this.state.slidesToShow, !0);
    });
  }, Carousel.prototype.setIsInThrottle = function (isInThrottle) {
    void 0 === isInThrottle && (isInThrottle = !1), this.isInThrottle = isInThrottle;
  }, Carousel.prototype.setTransformDirectly = function (position, withAnimation) {
    var additionalTransfrom = this.props.additionalTransfrom,
        currentTransform = common_1.getTransform(this.state, this.props, position);
    this.transformPlaceHolder = position, this.listRef && this.listRef.current && (this.setAnimationDirectly(withAnimation), this.listRef.current.style.transform = "translate3d(" + (currentTransform + additionalTransfrom) + "px,0,0)");
  }, Carousel.prototype.setAnimationDirectly = function (animationAllowed) {
    this.listRef && this.listRef.current && (this.listRef.current.style.transition = animationAllowed ? this.props.customTransition || defaultTransition : "none");
  }, Carousel.prototype.componentDidMount = function () {
    this.setState({
      domLoaded: !0
    }), this.setItemsToShow(), window.addEventListener("resize", this.onResize), this.onResize(!0), this.props.keyBoardControl && window.addEventListener("keyup", this.onKeyUp), this.props.autoPlay && this.props.autoPlaySpeed && (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed));
  }, Carousel.prototype.setClones = function (slidesToShow, itemWidth, forResizing, resetCurrentSlide) {
    var _this = this;

    void 0 === resetCurrentSlide && (resetCurrentSlide = !1), this.isAnimationAllowed = !1;
    var childrenArr = React.Children.toArray(this.props.children),
        initialSlide = utils_1.getInitialSlideInInfiniteMode(slidesToShow || this.state.slidesToShow, childrenArr),
        clones = utils_1.getClones(this.state.slidesToShow, childrenArr),
        currentSlide = childrenArr.length < this.state.slidesToShow ? 0 : this.state.currentSlide;
    this.setState({
      totalItems: clones.length,
      currentSlide: forResizing && !resetCurrentSlide ? currentSlide : initialSlide
    }, function () {
      _this.correctItemsPosition(itemWidth || _this.state.itemWidth);
    });
  }, Carousel.prototype.setItemsToShow = function (shouldCorrectItemPosition, resetCurrentSlide) {
    var _this = this,
        responsive = this.props.responsive;

    Object.keys(responsive).forEach(function (item) {
      var _a = responsive[item],
          breakpoint = _a.breakpoint,
          items = _a.items,
          max = breakpoint.max,
          min = breakpoint.min;
      window.innerWidth >= min && window.innerWidth <= max && (_this.setState({
        slidesToShow: items,
        deviceType: item
      }), _this.setContainerAndItemWidth(items, shouldCorrectItemPosition, resetCurrentSlide));
    });
  }, Carousel.prototype.setContainerAndItemWidth = function (slidesToShow, shouldCorrectItemPosition, resetCurrentSlide) {
    var _this = this;

    if (this.containerRef && this.containerRef.current) {
      var containerWidth = this.containerRef.current.offsetWidth,
          itemWidth_1 = utils_1.getItemClientSideWidth(this.props, slidesToShow, containerWidth);
      this.setState({
        containerWidth: containerWidth,
        itemWidth: itemWidth_1
      }, function () {
        _this.props.infinite && _this.setClones(slidesToShow, itemWidth_1, shouldCorrectItemPosition, resetCurrentSlide);
      }), shouldCorrectItemPosition && this.correctItemsPosition(itemWidth_1);
    }
  }, Carousel.prototype.correctItemsPosition = function (itemWidth, isAnimationAllowed, setToDomDirectly) {
    isAnimationAllowed && (this.isAnimationAllowed = !0), !isAnimationAllowed && this.isAnimationAllowed && (this.isAnimationAllowed = !1);
    var nextTransform = this.state.totalItems < this.state.slidesToShow ? 0 : -itemWidth * this.state.currentSlide;
    setToDomDirectly && this.setTransformDirectly(nextTransform, !0), this.setState({
      transform: nextTransform
    });
  }, Carousel.prototype.onResize = function (value) {
    var shouldCorrectItemPosition;
    shouldCorrectItemPosition = !!this.props.infinite && ("boolean" != typeof value || !value), this.setItemsToShow(shouldCorrectItemPosition);
  }, Carousel.prototype.componentDidUpdate = function (_a, _b) {
    var _this = this,
        keyBoardControl = _a.keyBoardControl,
        autoPlay = _a.autoPlay,
        children = _a.children,
        containerWidth = _b.containerWidth,
        domLoaded = _b.domLoaded,
        currentSlide = _b.currentSlide;

    this.containerRef && this.containerRef.current && this.containerRef.current.offsetWidth !== containerWidth && (this.itemsToShowTimeout && clearTimeout(this.itemsToShowTimeout), this.itemsToShowTimeout = setTimeout(function () {
      _this.setItemsToShow(!0);
    }, this.props.transitionDuration || defaultTransitionDuration)), keyBoardControl && !this.props.keyBoardControl && window.removeEventListener("keyup", this.onKeyUp), !keyBoardControl && this.props.keyBoardControl && window.addEventListener("keyup", this.onKeyUp), autoPlay && !this.props.autoPlay && this.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0), autoPlay || !this.props.autoPlay || this.autoPlay || (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed)), children.length !== this.props.children.length ? setTimeout(function () {
      _this.props.infinite ? _this.setClones(_this.state.slidesToShow, _this.state.itemWidth, !0, !0) : _this.resetTotalItems();
    }, this.props.transitionDuration || defaultTransitionDuration) : this.props.infinite && this.state.currentSlide !== currentSlide && this.correctClonesPosition({
      domLoaded: domLoaded
    }), this.transformPlaceHolder !== this.state.transform && (this.transformPlaceHolder = this.state.transform);
  }, Carousel.prototype.correctClonesPosition = function (_a) {
    var _this = this,
        domLoaded = _a.domLoaded,
        childrenArr = React.Children.toArray(this.props.children),
        _b = utils_1.checkClonesPosition(this.state, childrenArr, this.props),
        isReachingTheEnd = _b.isReachingTheEnd,
        isReachingTheStart = _b.isReachingTheStart,
        nextSlide = _b.nextSlide,
        nextPosition = _b.nextPosition;

    this.state.domLoaded && domLoaded && (isReachingTheEnd || isReachingTheStart) && (this.isAnimationAllowed = !1, setTimeout(function () {
      _this.setState({
        transform: nextPosition,
        currentSlide: nextSlide
      });
    }, this.props.transitionDuration || defaultTransitionDuration));
  }, Carousel.prototype.next = function (slidesHavePassed) {
    var _this = this;

    void 0 === slidesHavePassed && (slidesHavePassed = 0);
    var _a = this.props,
        afterChange = _a.afterChange,
        beforeChange = _a.beforeChange;

    if (!utils_1.notEnoughChildren(this.state)) {
      var _b = utils_1.populateNextSlides(this.state, this.props, slidesHavePassed),
          nextSlides = _b.nextSlides,
          nextPosition = _b.nextPosition,
          previousSlide = this.state.currentSlide;

      void 0 !== nextSlides && void 0 !== nextPosition && ("function" == typeof beforeChange && beforeChange(nextSlides, this.getState()), this.isAnimationAllowed = !0, this.setState({
        transform: nextPosition,
        currentSlide: nextSlides
      }, function () {
        "function" == typeof afterChange && setTimeout(function () {
          afterChange(previousSlide, _this.getState());
        }, _this.props.transitionDuration || defaultTransitionDuration);
      }));
    }
  }, Carousel.prototype.previous = function (slidesHavePassed) {
    var _this = this;

    void 0 === slidesHavePassed && (slidesHavePassed = 0);
    var _a = this.props,
        afterChange = _a.afterChange,
        beforeChange = _a.beforeChange;

    if (!utils_1.notEnoughChildren(this.state)) {
      var _b = utils_1.populatePreviousSlides(this.state, this.props, slidesHavePassed),
          nextSlides = _b.nextSlides,
          nextPosition = _b.nextPosition;

      if (void 0 !== nextSlides && void 0 !== nextPosition) {
        var previousSlide = this.state.currentSlide;
        "function" == typeof beforeChange && beforeChange(nextSlides, this.getState()), this.isAnimationAllowed = !0, this.setState({
          transform: nextPosition,
          currentSlide: nextSlides
        }, function () {
          "function" == typeof afterChange && setTimeout(function () {
            afterChange(previousSlide, _this.getState());
          }, _this.props.transitionDuration || defaultTransitionDuration);
        });
      }
    }
  }, Carousel.prototype.componentWillUnmount = function () {
    window.removeEventListener("resize", this.onResize), this.props.keyBoardControl && window.removeEventListener("keyup", this.onKeyUp), this.props.autoPlay && this.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0), this.itemsToShowTimeout && clearTimeout(this.itemsToShowTimeout);
  }, Carousel.prototype.resetMoveStatus = function () {
    this.onMove = !1, this.initialX = 0, this.lastX = 0, this.direction = "", this.initialY = 0;
  }, Carousel.prototype.handleDown = function (e) {
    if (!(!types_1.isMouseMoveEvent(e) && !this.props.swipeable || types_1.isMouseMoveEvent(e) && !this.props.draggable || this.isInThrottle)) {
      var _a = types_1.isMouseMoveEvent(e) ? e : e.touches[0],
          clientX = _a.clientX,
          clientY = _a.clientY;

      this.onMove = !0, this.initialX = clientX, this.initialY = clientY, this.lastX = clientX, this.isAnimationAllowed = !1;
    }
  }, Carousel.prototype.handleMove = function (e) {
    if (!(!types_1.isMouseMoveEvent(e) && !this.props.swipeable || types_1.isMouseMoveEvent(e) && !this.props.draggable || utils_1.notEnoughChildren(this.state))) {
      var _a = types_1.isMouseMoveEvent(e) ? e : e.touches[0],
          clientX = _a.clientX,
          clientY = _a.clientY,
          diffX = this.initialX - clientX,
          diffY = this.initialY - clientY;

      if (this.onMove) {
        if (!(Math.abs(diffX) > Math.abs(diffY))) return;

        var _b = utils_1.populateSlidesOnMouseTouchMove(this.state, this.props, this.initialX, this.lastX, clientX, this.transformPlaceHolder),
            direction = _b.direction,
            nextPosition = _b.nextPosition,
            canContinue = _b.canContinue;

        direction && (this.direction = direction, canContinue && void 0 !== nextPosition && this.setTransformDirectly(nextPosition)), this.lastX = clientX;
      }
    }
  }, Carousel.prototype.handleOut = function (e) {
    this.props.autoPlay && !this.autoPlay && (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed));
    var shouldDisableOnMobile = "touchend" === e.type && !this.props.swipeable,
        shouldDisableOnDesktop = ("mouseleave" === e.type || "mouseup" === e.type) && !this.props.draggable;

    if (!shouldDisableOnMobile && !shouldDisableOnDesktop && this.onMove) {
      if (this.setAnimationDirectly(!0), "right" === this.direction) if (this.initialX - this.lastX >= this.props.minimumTouchDrag) {
        var slidesHavePassed = Math.round((this.initialX - this.lastX) / this.state.itemWidth);
        this.next(slidesHavePassed);
      } else this.correctItemsPosition(this.state.itemWidth, !0, !0);
      if ("left" === this.direction) if (this.lastX - this.initialX > this.props.minimumTouchDrag) {
        slidesHavePassed = Math.round((this.lastX - this.initialX) / this.state.itemWidth);
        this.previous(slidesHavePassed);
      } else this.correctItemsPosition(this.state.itemWidth, !0, !0);
      this.resetMoveStatus();
    }
  }, Carousel.prototype.isInViewport = function (el) {
    var _a = el.getBoundingClientRect(),
        _b = _a.top,
        top = void 0 === _b ? 0 : _b,
        _c = _a.left,
        left = void 0 === _c ? 0 : _c,
        _d = _a.bottom,
        bottom = void 0 === _d ? 0 : _d,
        _e = _a.right,
        right = void 0 === _e ? 0 : _e;

    return 0 <= top && 0 <= left && bottom <= (window.innerHeight || document.documentElement.clientHeight) && right <= (window.innerWidth || document.documentElement.clientWidth);
  }, Carousel.prototype.isChildOfCarousel = function (el) {
    return !!(el instanceof Element && this.listRef && this.listRef.current) && this.listRef.current.contains(el);
  }, Carousel.prototype.onKeyUp = function (e) {
    var target = e.target;

    switch (e.keyCode) {
      case 37:
        if (this.isChildOfCarousel(target)) return this.previous();
        break;

      case 39:
        if (this.isChildOfCarousel(target)) return this.next();
        break;

      case 9:
        if (this.isChildOfCarousel(target) && target instanceof HTMLInputElement && !this.isInViewport(target)) return this.next();
    }
  }, Carousel.prototype.handleEnter = function (e) {
    types_1.isMouseMoveEvent(e) && this.autoPlay && this.props.autoPlay && this.props.pauseOnHover && (clearInterval(this.autoPlay), this.autoPlay = void 0);
  }, Carousel.prototype.goToSlide = function (slide, skipCallbacks) {
    var _this = this;

    if (!this.isInThrottle) {
      var itemWidth = this.state.itemWidth,
          _a = this.props,
          afterChange = _a.afterChange,
          beforeChange = _a.beforeChange,
          previousSlide = this.state.currentSlide;
      "function" != typeof beforeChange || skipCallbacks && ("object" != typeof skipCallbacks || skipCallbacks.skipBeforeChange) || beforeChange(slide, this.getState()), this.isAnimationAllowed = !0, this.setState({
        currentSlide: slide,
        transform: -itemWidth * slide
      }, function () {
        _this.props.infinite && _this.correctClonesPosition({
          domLoaded: !0
        }), "function" != typeof afterChange || skipCallbacks && ("object" != typeof skipCallbacks || skipCallbacks.skipAfterChange) || setTimeout(function () {
          afterChange(previousSlide, _this.getState());
        }, _this.props.transitionDuration || defaultTransitionDuration);
      });
    }
  }, Carousel.prototype.getState = function () {
    return this.state;
  }, Carousel.prototype.renderLeftArrow = function (disbaled) {
    var _this = this,
        customLeftArrow = this.props.customLeftArrow;

    return React.createElement(Arrows_1.LeftArrow, {
      customLeftArrow: customLeftArrow,
      getState: function getState() {
        return _this.getState();
      },
      previous: this.previous,
      disabled: disbaled
    });
  }, Carousel.prototype.renderRightArrow = function (disbaled) {
    var _this = this,
        customRightArrow = this.props.customRightArrow;

    return React.createElement(Arrows_1.RightArrow, {
      customRightArrow: customRightArrow,
      getState: function getState() {
        return _this.getState();
      },
      next: this.next,
      disabled: disbaled
    });
  }, Carousel.prototype.renderButtonGroups = function () {
    var _this = this,
        customButtonGroup = this.props.customButtonGroup;

    return customButtonGroup ? React.cloneElement(customButtonGroup, {
      previous: function previous() {
        return _this.previous();
      },
      next: function next() {
        return _this.next();
      },
      goToSlide: function goToSlide(slideIndex, skipCallbacks) {
        return _this.goToSlide(slideIndex, skipCallbacks);
      },
      carouselState: this.getState()
    }) : null;
  }, Carousel.prototype.renderDotsList = function () {
    var _this = this;

    return React.createElement(Dots_1.default, {
      state: this.state,
      props: this.props,
      goToSlide: this.goToSlide,
      getState: function getState() {
        return _this.getState();
      }
    });
  }, Carousel.prototype.renderCarouselItems = function () {
    var clones = [];

    if (this.props.infinite) {
      var childrenArr = React.Children.toArray(this.props.children);
      clones = utils_1.getClones(this.state.slidesToShow, childrenArr);
    }

    return React.createElement(CarouselItems_1.default, {
      clones: clones,
      goToSlide: this.goToSlide,
      state: this.state,
      notEnoughChildren: utils_1.notEnoughChildren(this.state),
      props: this.props
    });
  }, Carousel.prototype.render = function () {
    var _a = this.props,
        deviceType = _a.deviceType,
        arrows = _a.arrows,
        renderArrowsWhenDisabled = _a.renderArrowsWhenDisabled,
        removeArrowOnDeviceType = _a.removeArrowOnDeviceType,
        infinite = _a.infinite,
        containerClass = _a.containerClass,
        sliderClass = _a.sliderClass,
        customTransition = _a.customTransition,
        additionalTransfrom = _a.additionalTransfrom,
        renderDotsOutside = _a.renderDotsOutside,
        renderButtonGroupOutside = _a.renderButtonGroupOutside,
        className = _a.className;
    "production" !== process.env.NODE_ENV && utils_1.throwError(this.state, this.props);

    var _b = utils_1.getInitialState(this.state, this.props),
        shouldRenderOnSSR = _b.shouldRenderOnSSR,
        shouldRenderAtAll = _b.shouldRenderAtAll,
        isLeftEndReach = utils_1.isInLeftEnd(this.state),
        isRightEndReach = utils_1.isInRightEnd(this.state),
        shouldShowArrows = arrows && !(removeArrowOnDeviceType && (deviceType && -1 < removeArrowOnDeviceType.indexOf(deviceType) || this.state.deviceType && -1 < removeArrowOnDeviceType.indexOf(this.state.deviceType))) && !utils_1.notEnoughChildren(this.state) && shouldRenderAtAll,
        disableLeftArrow = !infinite && isLeftEndReach,
        disableRightArrow = !infinite && isRightEndReach,
        currentTransform = common_1.getTransform(this.state, this.props);

    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "react-multi-carousel-list " + containerClass + " " + className,
      ref: this.containerRef
    }, React.createElement("ul", {
      ref: this.listRef,
      className: "react-multi-carousel-track " + sliderClass,
      style: {
        transition: this.isAnimationAllowed ? customTransition || defaultTransition : "none",
        overflow: shouldRenderOnSSR ? "hidden" : "unset",
        transform: "translate3d(" + (currentTransform + additionalTransfrom) + "px,0,0)"
      },
      onMouseMove: this.handleMove,
      onMouseDown: this.handleDown,
      onMouseUp: this.handleOut,
      onMouseEnter: this.handleEnter,
      onMouseLeave: this.handleOut,
      onTouchStart: this.handleDown,
      onTouchMove: this.handleMove,
      onTouchEnd: this.handleOut
    }, this.renderCarouselItems()), shouldShowArrows && (!disableLeftArrow || renderArrowsWhenDisabled) && this.renderLeftArrow(disableLeftArrow), shouldShowArrows && (!disableRightArrow || renderArrowsWhenDisabled) && this.renderRightArrow(disableRightArrow), shouldRenderAtAll && !renderButtonGroupOutside && this.renderButtonGroups(), shouldRenderAtAll && !renderDotsOutside && this.renderDotsList()), shouldRenderAtAll && renderDotsOutside && this.renderDotsList(), shouldRenderAtAll && renderButtonGroupOutside && this.renderButtonGroups());
  }, Carousel.defaultProps = {
    slidesToSlide: 1,
    infinite: !1,
    draggable: !0,
    swipeable: !0,
    arrows: !0,
    renderArrowsWhenDisabled: !1,
    containerClass: "",
    sliderClass: "",
    itemClass: "",
    keyBoardControl: !0,
    autoPlaySpeed: 3e3,
    showDots: !1,
    renderDotsOutside: !1,
    renderButtonGroupOutside: !1,
    minimumTouchDrag: 80,
    className: "",
    dotListClass: "",
    focusOnSelect: !1,
    centerMode: !1,
    additionalTransfrom: 0,
    pauseOnHover: !0
  }, Carousel;
}(React.Component);

exports.default = Carousel;